import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const OGEET_LOGO = 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/v4l14fbp_ChatGPT%20Image%20May%205%2C%202026%2C%2010_48_05%20PM.png';
const OGEET_BG = 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/qiqyydwv_file_00000000cfa071f493330a6835986159.png';
const OGEET_HERO = 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/fxn7pla1_IMG-20260402-WA0255%281%29.jpg';
const GEET_LOGO = '/geet-neon.png';

const LandingPage = () => {
  const [hovered, setHovered] = useState(null); // 'geet' | 'ogeet' | null

  return (
    <main
      data-testid="landing-page"
      className="relative w-full min-h-screen overflow-x-hidden flex flex-col md:flex-row md:fixed md:inset-0 md:h-screen md:overflow-hidden bg-black"
    >
      {/* GEET — Fine Dining */}
      <Link
        to="/geet"
        data-testid="enter-geet"
        onMouseEnter={() => setHovered('geet')}
        onMouseLeave={() => setHovered(null)}
        className={`group relative flex-1 min-h-[47vh] md:min-h-0 overflow-hidden transition-[flex] duration-700 ease-[cubic-bezier(0.6,0.05,0.28,0.91)] ${
          hovered === 'ogeet' ? 'md:flex-[0.7]' : hovered === 'geet' ? 'md:flex-[1.3]' : ''
        }`}
      >
        {/* Background photo */}
        <div className="absolute inset-0">
          <img
            src="https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/i967kzb2_ChatGPT%20Image%20Jun%2015%2C%202026%2C%2010_13_24%20AM.png"
            alt="Geet fine dining interior at sunset"
            className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[2000ms] ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#1C1917]/80 via-[#1C1917]/55 to-[#1C1917]/80 group-hover:from-[#1C1917]/65 group-hover:to-[#1C1917]/70 transition-all duration-700" />
        </div>

        {/* Decorative gold border */}
        <div className="absolute inset-0 border-r-0 md:border-r-[1px] border-b-[1px] md:border-b-0 border-[#C9A227]/40" />

        {/* Content */}
        <div className="relative h-full flex flex-col items-center justify-center px-6 md:px-12 py-8 md:py-0 text-center">
          {/* Top label */}
          <div className="absolute top-4 md:top-12 left-1/2 -translate-x-1/2 flex items-center gap-3 opacity-70 group-hover:opacity-100 transition-opacity duration-500">
            <div className="h-px w-8 bg-[#C9A227]" />
            <span className="font-['Cormorant_Garamond'] italic text-[#C9A227] text-sm md:text-base tracking-[0.3em] uppercase whitespace-nowrap">
              Since 2010
            </span>
            <div className="h-px w-8 bg-[#C9A227]" />
          </div>

          <img
            src={GEET_LOGO}
            alt="Geet Fine Dining"
            className="h-16 sm:h-20 md:h-36 lg:h-44 w-auto mb-3 md:mb-8 transition-all duration-700 group-hover:scale-105 drop-shadow-[0_8px_24px_rgba(0,0,0,0.5)]"
          />

          <h2 className="font-['Marcellus'] text-xl sm:text-2xl md:text-3xl lg:text-4xl text-[#FAF6F0] tracking-[0.15em] mb-2 md:mb-3">
            FINE DINING
          </h2>
          <p className="hidden md:block font-['Cormorant_Garamond'] italic text-base md:text-lg lg:text-xl text-[#FAF6F0]/70 max-w-md mb-10">
            A contemporary take on classic Indian curries, seafood &amp; tandoori — in a smart, exotic space.
          </p>
          <p className="md:hidden font-['Cormorant_Garamond'] italic text-sm text-[#FAF6F0]/70 max-w-xs mb-5">
            Classic Indian fine dining.
          </p>

          {/* CTA */}
          <div className="inline-flex items-center gap-3 border border-[#C9A227] text-[#C9A227] px-8 md:px-10 py-3 md:py-4 font-['Cormorant_Garamond'] tracking-[0.3em] uppercase text-sm md:text-base group-hover:bg-[#C9A227] group-hover:text-[#1C1917] transition-all duration-500">
            Enter Geet
            <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1" />
          </div>
        </div>

        {/* Corner ornament */}
        <div className="absolute bottom-8 left-8 hidden md:flex items-center gap-2 text-[#C9A227]/50 text-xs tracking-[0.3em] font-['Cormorant_Garamond']">
          <span>✦</span>
          <span>RAJ PALACE EXPERIENCE</span>
        </div>
      </Link>

      {/* OGEET — Café & Lounge (Coming Soon) */}
      <Link
        to="/ogeet"
        data-testid="enter-ogeet"
        onMouseEnter={() => setHovered('ogeet')}
        onMouseLeave={() => setHovered(null)}
        className={`group relative flex-1 min-h-[47vh] md:min-h-0 overflow-hidden transition-[flex] duration-700 ease-[cubic-bezier(0.6,0.05,0.28,0.91)] ${
          hovered === 'geet' ? 'md:flex-[0.7]' : hovered === 'ogeet' ? 'md:flex-[1.3]' : ''
        }`}
      >
        {/* Golden lounge backdrop */}
        <div className="absolute inset-0">
          <img
            src={OGEET_BG}
            alt="OGeet Café & Lounge interior"
            className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[2000ms] ease-out"
          />
          {/* Readability + mood overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/30 to-black/55 group-hover:from-black/45 group-hover:to-black/40 transition-all duration-700" />
        </div>

        {/* Subtle festival accents */}
        <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-[#FF1493] opacity-20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 right-0 w-80 h-80 rounded-full bg-[#FFB300] opacity-20 blur-3xl pointer-events-none" />

        {/* Grain */}
        <div
          className="absolute inset-0 opacity-15 mix-blend-overlay pointer-events-none"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='400' height='400' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E\")",
          }}
        />

        {/* Content */}
        <div className="relative h-full flex flex-col items-center justify-center px-6 md:px-12 py-16 md:py-0 text-center">
          {/* Top label */}
          <div className="absolute top-4 md:top-12 left-1/2 -translate-x-1/2 flex items-center gap-3">
            <div className="h-px w-8 bg-[#FFE082]" />
            <span className="flex items-center gap-2 font-['Cormorant_Garamond'] italic text-[#FFE082] text-sm md:text-base tracking-[0.3em] uppercase whitespace-nowrap drop-shadow">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FFE082] opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FFE082]" />
              </span>
              Now Open
            </span>
            <div className="h-px w-8 bg-[#FFE082]" />
          </div>

          {/* OGeet logo */}
          <img
            src={OGEET_LOGO}
            alt="OGeet Café & Lounge"
            className="h-20 sm:h-24 md:h-44 lg:h-56 w-auto mb-3 md:mb-8 transition-transform duration-700 group-hover:scale-105 drop-shadow-[0_10px_40px_rgba(0,0,0,0.4)]"
            style={{ mixBlendMode: 'screen' }}
          />

          <h2 className="font-['Marcellus'] text-xl sm:text-2xl md:text-3xl lg:text-4xl text-[#FFF8E1] tracking-[0.15em] mb-2 md:mb-3 drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]">
            CAFÉ &amp; LOUNGE
          </h2>
          <p className="hidden md:block font-['Cormorant_Garamond'] italic text-base md:text-lg lg:text-xl text-[#FFF8E1]/90 max-w-md mb-10 drop-shadow">
            A vibrant new chapter from Gita — where Indian flavour meets modern lounge culture.
          </p>
          <p className="md:hidden font-['Cormorant_Garamond'] italic text-sm text-[#FFF8E1]/90 max-w-xs mb-5 drop-shadow">
            Indian flavour, modern lounge.
          </p>

          {/* CTA */}
          <div className="inline-flex items-center gap-3 border-2 border-[#FFD54F] bg-[#FFD54F]/10 backdrop-blur-sm text-[#FFF8E1] px-8 md:px-10 py-3 md:py-4 font-['Cormorant_Garamond'] tracking-[0.3em] uppercase text-sm md:text-base group-hover:bg-[#FFD54F] group-hover:text-[#6A1B9A] transition-all duration-500">
            Visit OGeet
            <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1" />
          </div>
        </div>

        {/* Corner ornament */}
        <div className="absolute bottom-8 right-8 hidden md:flex items-center gap-2 text-[#FFD54F]/80 text-xs tracking-[0.3em] font-['Cormorant_Garamond']">
          <span>CAFÉ &amp; LOUNGE</span>
          <span>✦</span>
        </div>
      </Link>

      {/* Center divider with "OR" — desktop only */}
      <div className="hidden md:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 pointer-events-none">
        <div
          className={`flex items-center justify-center w-16 h-16 rounded-full border border-[#FFD54F]/40 backdrop-blur-md bg-black/30 text-[#FFD54F] font-['Cormorant_Garamond'] italic text-xl tracking-wider transition-all duration-700 ${
            hovered ? 'opacity-0 scale-90' : 'opacity-100 scale-100'
          }`}
        >
          or
        </div>
      </div>

      {/* Tiny brand mark — top center on desktop, bottom strip on mobile */}
      <div className="relative md:absolute md:top-6 left-0 md:left-1/2 md:-translate-x-1/2 w-full md:w-auto text-center py-3 md:py-0 bg-black md:bg-transparent z-20 pointer-events-none border-t border-white/10 md:border-0">
        <p className="font-['Cormorant_Garamond'] italic text-white/60 text-xs md:text-sm tracking-[0.4em] uppercase">
          By Gita ·  Pretoria
        </p>
      </div>
    </main>
  );
};

export default LandingPage;
